import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdateEventQuestionnaireTemplateInput {
  eventId: number;
  templateId: number;
}

export interface UpdateEventQuestionnaireTemplateResult {
  updateEventQuestionnaireTemplate: {
    ok: boolean;
  };
}

const UpdateEventQuestionnaireTemplateMutation = gql`
  mutation updateEventQuestionnaireTemplate($input: UpdateEventQuestionnaireTemplateInput!) {
    updateEventQuestionnaireTemplate(input: $input) {
      ok
    }
  }
`;

export const updateEventQuestionnaireTemplate = (
  input: UpdateEventQuestionnaireTemplateInput
): Promise<UpdateEventQuestionnaireTemplateResult> => {
  return gqlClient.request<UpdateEventQuestionnaireTemplateResult>(
    UpdateEventQuestionnaireTemplateMutation,
    {
      input
    }
  );
};
